var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{attrs:{"id":"forgot-password","type":"button"},on:{"click":function($event){return _vm.requestNewPassword()}}},[_vm._v("\n    Esqueci minha senha.\n    "),_c('i',{staticClass:"fa fa-spinner fa-pulse",attrs:{"id":"spin"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }